"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.right = exports.left = exports.Either = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "Either", { enumerable: true, get: function () { return features_1.Either; } });
Object.defineProperty(exports, "left", { enumerable: true, get: function () { return features_1.left; } });
Object.defineProperty(exports, "right", { enumerable: true, get: function () { return features_1.right; } });
//# sourceMappingURL=index.js.map